
namespace SorAraBul.Administration {
    export class UserCreditLogColumns {
        static columnsKey = 'Administration.UserCreditLog';
    }
}